// DO NOT CHANGE THIS FILE
export const assemblyDate = new Date(1717862077641)
